import React, { useEffect, useState } from 'react'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box, Link, Button, Dialog, DialogContent, IconButton, Tooltip } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { CloseOutlined, Info } from '@mui/icons-material';
import { ApiGetInvoiceItem } from '../../../../apiService/Core/Apicall.tsx';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import Loading from '../../../Loader/Loading.tsx';

function Invoicedetails({ selectedDate }) {
    const location = useLocation()
    const navigate = useNavigate()
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const [bigImg, setbigImg] = useState<boolean>(false)
    const [showImg, setshowImg] = useState<any>([])
    const [invoiceItem, setInvoiceItem] = useState<any>([]);
    const loading = useSelector((state: any) => state.loader.isLoading);




    function createData2(
        img: any,
        visitDate: string,
        Venue: string,
        Score: number,
        Price: number,
        Food: string,
        Bar: string,
        Gaming: number,
        Battleshop: string,
        Bonus: string,
        pennulty: string,
        total: number,
    ) {
        return { img, visitDate, Venue, Score, Price, Food, Bar, Gaming, Battleshop, Bonus, pennulty, total };
    }

    const rows2 = [
        createData2(['https://img.freepik.com/free-photo/closeup-scarlet-macaw-from-side-view-scarlet-macaw-closeup-head_488145-3540.jpg?semt=ais_hybrid&w=740', 'https://cdn.pixabay.com/photo/2024/05/26/10/15/bird-8788491_1280.jpg', 'https://images.pexels.com/photos/1054655/pexels-photo-1054655.jpeg?cs=srgb&dl=pexels-hsapir-1054655.jpg&fm=jpg', 'https://images.unsplash.com/photo-1575936123452-b67c3203c357?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aW1hZ2V8ZW58MHx8MHx8fDA%3D'], '30/04/2025', "Willow Hotel", 55.17, 90.00, "N/A", "N/A", 30.00, "N/A", "N/A", "N/A", 4.0),
        createData2(['https://img.freepik.com/free-photo/closeup-scarlet-macaw-from-side-view-scarlet-macaw-closeup-head_488145-3540.jpg?semt=ais_hybrid&w=740', 'https://tinypng.com/images/social/website.jpg'], '30/04/2025', "Willow Hotel", 55.17, 90.00, "N/A", "N/A", 30.00, "N/A", "N/A", "N/A", 4.0),
    ];
    const images = showImg.length > 0 && showImg?.map(img => ({
        original: img,
        thumbnail: img,
    }));

    const getInvoiveItem = async () => {
        setInvoiceItem([])
        try {
            // const data = `?userId=${userData.userId}&month=${selectedDate.month() + 1}&year=${selectedDate.year()}`
            const data = `?userId=${userData.userId}&shopperInvoiceId=${location?.state?.shopperInvoiceId}`
            const res = await ApiGetInvoiceItem(data)
            setInvoiceItem(res.data.invoiceList)
        } catch (error) {
             const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
        }

    }
    useEffect(() => {
        getInvoiveItem()
    }, [selectedDate])

    return (
        <Box>
            <Typography variant='subtitle1' className='mb-3'><Link href='/dashboard/invoices' className='text-main' sx={{ textDecorationColor: '#ABD792' }} onClick={() => { navigate(-1) }}>invoices</Link> / Invoice: #{location?.state?.shopperInvoiceId}</Typography>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {/* <TableCell sx={{width:'50px'}}></TableCell> */}
                            <TableCell>Visit Date</TableCell>
                            <TableCell>Venue</TableCell>
                            <TableCell>Score</TableCell>
                            <TableCell>Price</TableCell>
                            <TableCell>Food</TableCell>
                            <TableCell>Bar</TableCell>
                            <TableCell>Gaming</TableCell>
                            <TableCell>Bottelshop</TableCell>
                            <TableCell>Bonus</TableCell>
                            <TableCell>Penalty</TableCell>
                            <TableCell>Total</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {invoiceItem.length > 0 ? (invoiceItem?.map((row, index) => (
                            <React.Fragment>
                                <TableRow
                                    key={row.index}
                                    // className='flex-wrap'
                                    sx={{ 'td,th': { border: 0 } }}
                                >
                                    <TableCell>
                                        {dayjs(row?.inspectionDateTime).format('DD/MM/YYYY')}
                                        <Typography variant='body2' className='text-secondary'>{dayjs(row?.inspectionDateTime).format('hh:mm:ss A')}</Typography>
                                        {row.visitDate}
                                    </TableCell>
                                    <TableCell>{row?.venueName}</TableCell>
                                    <TableCell>{row?.reportScore}</TableCell>
                                    <TableCell>
                                        {row?.venuePriceDisplay}
                                        <br />
                                        <span className='fw-bold'>({row?.venuePrice})</span>
                                    </TableCell>
                                    <TableCell>{row?.spentFoodAmt}</TableCell>
                                    <TableCell>{row?.spentBarAmt}</TableCell>
                                    <TableCell>{row?.spentGamingAmt}</TableCell>
                                    <TableCell>{row?.spentBottleShopAmt}</TableCell>
                                    <TableCell>{row?.bonus}
                                        {row?.bonusReason && ( <Tooltip title={row?.bonusReason} arrow><Info className='ms-1 my-0 p-0' sx={{ fontSize: '16px' }} /></Tooltip>)}

                                    </TableCell>
                                    <TableCell>{row?.penalty}
                                      {row?.penaltyReason && (<Tooltip title={row?.penaltyReason} arrow><Info className='ms-1 my-0 p-0' sx={{ fontSize: '16px' }} /></Tooltip> )} 
                                    </TableCell>
                                    <TableCell>{row?.finalPayableAmt}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={11}>
                                        <Box display="flex" gap={1}>
                                            {row?.images?.map((item, index) => (
                                                <Box
                                                    key={index}
                                                    component="img"
                                                    src={item?.imageUrl ?? ''}
                                                    // alt={`img-${index}`}
                                                    height="100px"
                                                    width="100px"
                                                    borderRadius="5px"
                                                    sx={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        setbigImg(true);
                                                        setshowImg([...showImg, item?.imageUrl]);
                                                    }}
                                                />
                                            ))}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </React.Fragment>
                        ))) : <TableCell colSpan={11} className='text-center'><Typography>No Data Found</Typography></TableCell>}
                    </TableBody>
                </Table>
            </TableContainer>
            <Dialog className='fulldialog' open={bigImg} onClose={() => { setbigImg(false) }}>
                <DialogContent>
                    <Box position='relative' sx={{
                        maxHeight: 'calc(100vh - 500px) !important',
                        // backgroundColor: 'green',
                        '.image-gallery-center': {
                            backgroundColor: 'transparent',
                            maxHeight: 'calc(100vh - 180px)!important'
                        },
                        '.image-gallery-svg': {
                            color: '#ADB792'
                        }
                    }}>
                        <IconButton
                            onClick={() => setbigImg(false)}
                            sx={{ position: 'absolute', top: 8, right: 8, zIndex: 10, }}
                        >
                            <CloseOutlined sx={{ fontSize: '48px' }} />
                        </IconButton>
                        <ImageGallery items={images} showPlayButton={false} />
                    </Box>
                </DialogContent>
            </Dialog>
            {loading && <Loading />}
        </Box>

    )
}

export default Invoicedetails
